"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBPartnershipPositive = function SvgBPartnershipPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M122.645 76.11a2.096 2.096 0 01-1.482-3.579l8.157-8.185c13.601-13.601 13.601-35.653 0-49.254-13.6-13.601-35.652-13.601-49.253 0l-28.5 28.527a2.894 2.894 0 000 4.076 8.102 8.102 0 0010.563.804l19.768-14.89a2.097 2.097 0 012.335-.132c.16.097 16.86 9.786 32.917 1.055a2.097 2.097 0 112 3.684c-15.694 8.507-31.303 1.838-35.805-.468l-18.713 14.12a12.275 12.275 0 01-16.029-1.21 7.088 7.088 0 010-10.002l28.528-28.528a39.02 39.02 0 1155.181 55.182l-8.185 8.185a2.095 2.095 0 01-1.482.615z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M26.186 80.5a2.095 2.095 0 01-1.482-.615L12.12 67.303c-15.303-15.184-15.4-39.9-.217-55.203 15.184-15.303 39.9-15.4 55.203-.217a2.097 2.097 0 01-2.943 2.985C50.5 1.318 28.44 1.408 14.889 15.071c-13.55 13.663-13.46 35.724.203 49.275l12.583 12.582a2.097 2.097 0 010 2.964 2.097 2.097 0 01-1.49.608zM80.165 125.175a9.99 9.99 0 01-7.123-2.957 2.097 2.097 0 012.963-2.964 5.882 5.882 0 008.319-8.318l-1.839-1.887a2.097 2.097 0 112.964-2.964l1.88 1.88a10.08 10.08 0 01-7.13 17.203l-.034.007z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M93.984 116.423a9.99 9.99 0 01-7.123-2.957l-4.683-4.676a2.098 2.098 0 012.97-2.964l4.677 4.677a5.882 5.882 0 108.319-8.319l-16.581-16.58a2.097 2.097 0 012.964-2.965l16.588 16.581a10.08 10.08 0 01-7.13 17.203z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M105.274 105.134a10.052 10.052 0 01-7.13-2.95l-16.581-16.58a2.097 2.097 0 012.964-2.965l16.588 16.581a5.892 5.892 0 008.318-8.346L92.852 74.293a2.097 2.097 0 112.964-2.964l16.58 16.58a10.08 10.08 0 01-7.122 17.225z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M116.556 93.845c-2.676 0-5.24-1.07-7.123-2.971L92.852 74.293a2.097 2.097 0 112.964-2.964l16.58 16.58a5.882 5.882 0 008.32-8.318L90.6 49.498a2.098 2.098 0 012.964-2.97l30.121 30.12a10.073 10.073 0 01-7.13 17.197z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M67.806 125.343a9.717 9.717 0 01-6.872-16.588l7.962-7.962a9.718 9.718 0 1113.743 13.743l-7.962 7.962a9.682 9.682 0 01-6.871 2.845zm7.962-23.194a5.495 5.495 0 00-3.9 1.608l-7.977 7.962a5.524 5.524 0 107.808 7.815l7.99-7.969a5.515 5.515 0 00-3.907-9.416h-.014z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M54.343 117.234a9.71 9.71 0 01-6.865-16.574l12.45-12.45a9.717 9.717 0 1113.736 13.743l-12.45 12.443a9.682 9.682 0 01-6.871 2.838zm-3.901-13.61a5.522 5.522 0 007.808 7.808L70.7 98.976a5.522 5.522 0 10-7.787-7.809l-12.471 12.457z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M43.57 106.47A9.717 9.717 0 0136.7 89.88l12.457-12.45a9.717 9.717 0 0116.553 6.872 9.619 9.619 0 01-2.796 6.864l-12.471 12.457a9.682 9.682 0 01-6.872 2.845zm12.45-27.69a5.501 5.501 0 00-3.9 1.608L39.67 92.845a5.524 5.524 0 107.808 7.815l12.45-12.45a5.522 5.522 0 00-3.908-9.422v-.007z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M32.798 95.69a9.71 9.71 0 01-6.871-16.58l11.122-11.143a9.654 9.654 0 016.864-2.845 9.717 9.717 0 016.871 16.588L39.67 92.845a9.689 9.689 0 01-6.872 2.845zm11.136-26.374a5.48 5.48 0 00-3.9 1.614L28.89 82.073a5.522 5.522 0 107.808 7.808L47.842 78.74a5.522 5.522 0 00-3.908-9.423z",
    fill: "#285"
  })));
};

var _default = SvgBPartnershipPositive;
exports["default"] = _default;